"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  recipient: true,
  useSendVerificationEmailMutation: true,
  useCheckVerificationCodeMutation: true,
  useResendVerificationEmailMutation: true
};
exports.useResendVerificationEmailMutation = exports.useCheckVerificationCodeMutation = exports.useSendVerificationEmailMutation = exports.recipient = void 0;

var _EmptyAppApi = require("../EmptyAppApi");

var _timezones = require("./timezones/timezones");

Object.keys(_timezones).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _timezones[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _timezones[key];
    }
  });
});

var _gift = require("./gift/gift");

Object.keys(_gift).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _gift[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _gift[key];
    }
  });
});

var _code = require("./code/code");

Object.keys(_code).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _code[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _code[key];
    }
  });
});

var recipient = _EmptyAppApi.emptyAppApi.injectEndpoints({
  endpoints: function endpoints(build) {
    return {
      sendVerificationEmail: build.mutation({
        query: function query(hashId) {
          return {
            url: "/api/recipient/".concat(hashId, "/verification/send-email"),
            method: 'POST'
          };
        }
      }),
      resendVerificationEmail: build.mutation({
        query: function query(hashId) {
          return {
            url: "/api/recipient/".concat(hashId, "/verification/resend-email"),
            method: 'POST'
          };
        }
      }),
      checkVerificationCode: build.mutation({
        query: function query(_ref) {
          var hashId = _ref.hashId,
              code = _ref.code;
          return {
            url: "/api/recipient/".concat(hashId, "/verification/verify-code"),
            method: 'POST',
            body: {
              code: code
            }
          };
        }
      })
    };
  }
});

exports.recipient = recipient;
var useSendVerificationEmailMutation = recipient.useSendVerificationEmailMutation,
    useCheckVerificationCodeMutation = recipient.useCheckVerificationCodeMutation,
    useResendVerificationEmailMutation = recipient.useResendVerificationEmailMutation;
exports.useResendVerificationEmailMutation = useResendVerificationEmailMutation;
exports.useCheckVerificationCodeMutation = useCheckVerificationCodeMutation;
exports.useSendVerificationEmailMutation = useSendVerificationEmailMutation;